import { Layout, Modal } from "antd";
import Spinner from "../../layout/AppHeader/spinner";
const { Header } = Layout;
interface Props {
  isLoading?: boolean;
  status?: string;
  msjStatus?: string;
  msjIsLoading?: string;
  msjMsj?: string;
  title?: string;
  disabled?: boolean;
  isVisible?: boolean;
  success?: boolean;
  spinner?: boolean;
}
const ModalMsgCustoms: React.FC<Props> = ({
  isLoading,
  status,
  msjStatus,
  msjIsLoading,
  msjMsj,
  title = "Trabajando ahora",
  disabled,
  isVisible,
  success,
  spinner = true
}) => {
  const divSpinner = () => {
    if (spinner) {
      return (
        <Spinner></Spinner>)
        ;
    }
    return null;
  };

  return (
    <>
      <Modal
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
        title={title}
        open={isVisible}
        style={{ color: "brown" }}
        modalRender={(modal) => (
          <div
            style={{
              backgroundColor: "rgba(165, 42, 42, 0.05)", // Reemplaza maskStyle aquí
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            {modal}
          </div>
        )}
      >
        <Header style={{ backgroundColor: "#fff" }}>
          {divSpinner()}
          <div style={{ color: "brown" }}>{msjMsj}</div>
        </Header>
      </Modal>
    </>
  );
};
export default ModalMsgCustoms;
